"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedDateTime = _interopRequireDefault(require("I18n/components/FormattedDateTime"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Rating = _interopRequireDefault(require("ecosystem-marketplace-core/components/reviews/Rating"));

var _ReviewBody = _interopRequireDefault(require("ecosystem-marketplace-core/components/reviews/ReviewBody"));

var _ReviewerInfo = _interopRequireDefault(require("ecosystem-marketplace-core/components/reviews/ReviewerInfo"));

var _ReviewReplyThread = _interopRequireDefault(require("ecosystem-marketplace-core/components/reviews/ReviewReplyThread"));

var _colors = require("HubStyleTokens/colors");

var _ReviewAxes = require("ecosystem-marketplace-core/constants/reviews/ReviewAxes");

var _Review = _interopRequireDefault(require("ecosystem-marketplace-core/records/Review"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _HelpfulButton = _interopRequireDefault(require("./HelpfulButton"));

var _ReportButton = _interopRequireDefault(require("./ReportButton"));

var _withReportModalState = _interopRequireDefault(require("./withReportModalState"));

// Renders a complete review item given a review. ReviewsList iterates through
// a list of reviews and calls the Renderer to display each one
var DetailsReviewRenderer = function DetailsReviewRenderer(_ref) {
  var isCustomer = _ref.isCustomer,
      onReviewModalOpen = _ref.onReviewModalOpen,
      onReplyModalOpen = _ref.onReplyModalOpen,
      review = _ref.review,
      reviewModalOpen = _ref.reviewModalOpen,
      replyModalOpen = _ref.replyModalOpen,
      reportReviewModal = _ref.reportReviewModal,
      reportReplyModal = _ref.reportReplyModal;
  return _react.default.createElement("div", {
    className: "p-y-8",
    style: {
      minWidth: '700px',
      borderBottom: "1px solid " + _colors.GREAT_WHITE
    }
  }, _react.default.createElement(_UISection.default, null, _react.default.createElement(_Rating.default, {
    rating: review.get('ratings').get(_ReviewAxes.ReviewAxes.OVERALL),
    label: _react.default.createElement(_FormattedDateTime.default, {
      value: review.get('createdAt'),
      format: "ll",
      type: "userTz"
    })
  })), _react.default.createElement(_ReviewBody.default, {
    review: review
  }), _react.default.createElement(_ReviewerInfo.default, {
    inline: true,
    review: review
  }), _react.default.createElement(_UIList.default, {
    inline: true,
    use: "inline-divided",
    className: "m-top-8"
  }, _react.default.createElement(_HelpfulButton.default, {
    className: "m-right-2",
    isCustomer: isCustomer,
    review: review
  }), _react.default.createElement(_ReportButton.default, {
    className: "m-left-2",
    isCustomer: isCustomer,
    onClick: onReviewModalOpen
  })), _react.default.createElement(_ReviewReplyThread.default, {
    reply: review.get('reply'),
    onReportReplyClick: isCustomer ? onReplyModalOpen : undefined
  }), reviewModalOpen && reportReviewModal, replyModalOpen && reportReplyModal);
};

DetailsReviewRenderer.propTypes = {
  isCustomer: _propTypes.default.bool.isRequired,
  onReviewModalOpen: _propTypes.default.func.isRequired,
  onReplyModalOpen: _propTypes.default.func.isRequired,
  review: _propTypes.default.instanceOf(_Review.default).isRequired,
  reviewModalOpen: _propTypes.default.bool.isRequired,
  replyModalOpen: _propTypes.default.bool.isRequired,
  reportReviewModal: _propTypes.default.node.isRequired,
  reportReplyModal: _propTypes.default.node.isRequired
};

var _default = (0, _withReportModalState.default)(DetailsReviewRenderer);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/reviews/DetailsReviewRenderer.js
// module id = 852
// module chunks = 209 210 211 212